import { FavoriteStorage } from "./local-storage-functions";
import { toggleFavorite } from "./autocompletev2.js";
import geolocation from "./geolocation";
import slugify from "slugify";

let isSidebarInitialized = false;
const sidebar = {};

function createListItem({ label, href, city }, index) {
  const li = document.createElement('li');
  li.className = 'favorites-list-item';

  const a = document.createElement('a');
  a.href = href;
  a.textContent = label;
  a.id = `Menu_MainNav_Item_FavoriteLink-0${index + 1}`
  a.dataset.id = `Menu_MainNav_Item_FavoriteLink-0${index + 1}`

  const star = document.createElement('img');
  star.src = '/dist/images/v2/svg/star-filled.svg';
  star.alt = 'Cidade favorita';
  star.className = 'favorite-star-icon';
  star.setAttribute('role', 'button');
  star.setAttribute('aria-label', 'Remover dos favoritos');

  // Clique na estrela: alterna favorito
  const typeByPath = { 'cidade': 'city', 'litoral': 'beach', 'aeroporto': 'airport' };
  const type = typeByPath[String(city?.slug || '').split('/')[0]] || 'city';
  star.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggleFavorite(city, 'Menu_MainNav_Button_Star', type);
    // Atualiza a lista após o evento global
  });

  li.append(a);
  li.append(star);
  return li;
}

function buildCityMeta(place) {
  const name = place.cname;
  const uf = place.uf === 'ND' && place.ac ? place.ac : place.uf;
  const label = `${name} - ${uf}`;
  const slug = slugify(String(name)).replaceAll("-", "").toLowerCase();
  const href = `/previsao-do-tempo/cidade/${place.cid}/${slug}-${uf.toLowerCase()}`;
  return { name, uf, label, href };
}

sidebar.init = () => {
  if (isSidebarInitialized) {
    return;
  }
  const menuToggle = document.getElementById('menuToggle');
  const sidebarEl = document.getElementById('sidebar');
  const overlay = document.getElementById('overlay');

  if (!menuToggle || !sidebarEl || !overlay) {
    console.warn('Sidebar elements not found!');
    return;
  }

  const openSidebar = () => {
    sidebarEl.classList.add('is-open');
    overlay.classList.remove('hidden');
    document.body.classList.add('sidebar-is-open');
    menuToggle?.setAttribute('aria-expanded', 'true');
    const eventData = {
      event: 'open_element',
      id: 'Menu_MainNav',
    };
    pushDatalayer(eventData);
  };

  const closeSidebar = () => {
    sidebarEl.classList.remove('is-open');
    overlay.classList.add('hidden');
    document.body.classList.remove('sidebar-is-open');
    menuToggle?.setAttribute('aria-expanded', 'false');

    const activePanel = sidebarEl.querySelector('.sidebar-panel.is-active');
    if (activePanel) {
      activePanel.classList.remove('is-active');
    }
    document.getElementById('panel-main').classList.add('is-active');
    const eventData = {
      event: 'close_element',
      id: 'Menu_MainNav',
    };
    pushDatalayer(eventData);
  };

  menuToggle.addEventListener('click', openSidebar);
  overlay.addEventListener('click', closeSidebar);

  sidebar.updateUserProfile();
  sidebar.search.init()

  sidebar.handlePanelNavigation();
  sidebar.populateFavorites();
  sidebar.setupTracking();
  isSidebarInitialized = true;
};

sidebar.populateFavorites = () => {
  const favoriteBody = document.getElementById('favorites-list');
  if (!favoriteBody) return;

  let favorites = FavoriteStorage.get();

  if (Object.keys(favorites).length === 0) {
    favoriteBody.innerHTML = '<li class="no-favorites">Você não possui localidades favoritas</li>';
  } else {
    favoriteBody.innerHTML = '';
    let count = 0;
    favorites.forEach(favorite => {
      if (count < 3) {
        const meta = buildCityMeta(favorite.city);
        const li = createListItem({ label: meta.label, href: meta.href, city: favorite.city }, count);
        favoriteBody.append(li);
        count++;
      }
    });
  }
};

// Re-render quando favoritos mudarem
document.addEventListener('favoriteChanged', () => {
  try { sidebar.populateFavorites(); } catch (e) {}
});

sidebar.handlePanelNavigation = () => {
  const sidebarEl = document.getElementById('sidebar');

  sidebarEl.addEventListener('click', (e) => {
    const categoryLink = e.target.closest('.has-submenu');
    if (categoryLink) {
      e.preventDefault();
      const targetPanelId = categoryLink.dataset.targetPanel;
      const targetPanel = document.getElementById(targetPanelId);

      if (targetPanel) {
        sidebarEl.querySelector('.sidebar-panel.is-active').classList.remove('is-active');
        targetPanel.classList.add('is-active');
      }
    }

    const backButton = e.target.closest('.back-btn');
    if (backButton) {
      const targetPanelId = backButton.dataset.targetPanel;
      const targetPanel = document.getElementById(targetPanelId);

      if (targetPanel) {
        sidebarEl.querySelector('.sidebar-panel.is-active').classList.remove('is-active');
        targetPanel.classList.add('is-active');
      }
    }
  });
};

sidebar.setupTracking = () => {
  const sidebarEl = document.getElementById('sidebar');
  window.dataLayer = window.dataLayer || [];

  sidebarEl.addEventListener('click', (e) => {
    const backButton = e.target.closest('.back-btn');

    if (backButton) {
      const eventData = {
        event: 'click_button',
        id: backButton.dataset.id,
      };

      pushDatalayer(eventData);
    }
  });
};

sidebar.updateUserProfile = async () => {
  const userProfileBlock = document.getElementById('user-profile-block');
  if (!userProfileBlock) return;

  const isLogged = /(^| )SESSID=([^;]+)/.exec(document.cookie);
  const isDevelopment = window.location.hostname === 'www.climatempo.teste.com';
  if (!isLogged && !isDevelopment) return;

  let userData;
  if (isDevelopment) {
    console.warn('MODO DE DESENVOLVIMENTO: Usando dados de usuário simulados.');
    userData = {
      "_id": "66aa8b6c4b5e7f09d8c3e2a1", "name": "Fernanda Oliveira", "email": "fernanda.oliveira@example.com", "alternativeEmail": null, "birthday": "1992-07-15T00:00:00.000Z", "gender": "Feminino", "city": "Florianópolis", "children": 2, "formation": "Graduação", "profession": "Designer", "maritalStatus": "Casada", "phone": "(48) 98765-4321", "createdAt": "2024-05-20T10:30:00.000Z", "cities": [3495, 3667, 4052], "suggestions": [], "weatherPreferences": { "chill": 30, "heat": 80, "rain": 60 }, "welcomeIntro": false, "emailForecastPreferences": { "sun": true, "mon": true, "tue": false, "wed": true, "thu": false, "fri": true, "sat": false }
    };
  } else {
    userData = await fetchUserData();
    if (!userData) return;
  }

  if (!userData?.name) return;

  updateGreeting(userData.name);
  removeLoginLink();
  updateAvatar(userData);
};

async function fetchUserData() {
  try {
    const response = await fetch(`/json/myclimatempo/user/info?${Math.random(1, 1000)}`);
    if (!response.ok) {
      console.error('Falha na requisição de informações do usuário (produção).');
      return null;
    }
    return await response.json();
  } catch (error) {
    console.error('Erro ao buscar informações do usuário:', error);
    return null;
  }
}

function updateGreeting(name) {
  const greetingEl = document.getElementById('Menu_MainNav_Link_User');
  if (greetingEl) {
    const anchor = document.createElement('a');
    anchor.href = '/meu-climatempo/configuracoes';
    anchor.textContent = `Olá, ${name}`;
    anchor.id = 'Menu_MainNav_Link_User';
    anchor.setAttribute('data-id', anchor.id);

    greetingEl.replaceWith(anchor);
  }
}

function removeLoginLink() {
  const loginLinkEl = document.getElementById('Menu_MainNav_Link_Login');
  if (loginLinkEl) {
    loginLinkEl.remove();
  }
}

function updateAvatar(userData) {
  const avatarContainerEl = document.getElementById('sidebar-user-avatar-container');
  if (!avatarContainerEl) return;
  avatarContainerEl.innerHTML = '';

  if (userData.avatarUrl) {
    const avatarImg = document.createElement('img');
    avatarImg.src = userData.avatarUrl;
    avatarImg.alt = `Avatar de ${userData.name}`;
    avatarImg.className = 'sidebar-user-avatar';
    avatarContainerEl.appendChild(avatarImg);
  } else {
    const avatarInitial = createAvatarInitial(userData.name);
    avatarContainerEl.appendChild(avatarInitial);
  }
}

sidebar.search = {
  elements: {
    input: document.getElementById('sidebarSearchInput'),
    panel: document.getElementById('sidebarAutocompletePanel'),
    suggestionsUl: document.getElementById('sidebarAutocompleteSuggestions'),
    header: document.getElementById('sidebarAutocompleteHeader'),
    emptyMessage: document.getElementById('sidebarAutocompleteEmptyHistory'),
    myLocationButton: document.getElementById('sidebarSearchMyLocation'),
  },

  init: function () {
    if (!this.elements.input) return;
    this.setupInputListener();
    this.setupMyLocationButton();
  },

  setupInputListener: function () {
    const debouncedHandler = this.debounce(async () => {
      const query = this.elements.input.value?.trim();

      if (!query) {
        this.elements.panel.style.display = 'none';
        return;
      }

      this.elements.panel.style.display = 'block';

      if (query.length < 3) {
        this.renderSearchHistory();
        return;
      };

      try {
        const response = await $.ajax({
          url: '/json/busca-por-nome',
          type: "POST",
          dataType: "json",
          data: { name: query }
        });
        this.treatResponse(response);
      } catch (error) {
        console.error("Erro na busca da sidebar:", error);
      }
    }, 300);

    this.elements.input.addEventListener('input', debouncedHandler);
    this.elements.input.addEventListener('focus', debouncedHandler);
  },

  treatResponse: function (response) {
    const validTypes = ['city', 'beach', 'airport'];
    const suggestions = response
      .map(({ response: { data }, type }) => ({
        places: Array.isArray(data) ? data.slice(0, 5) : [],
        type: type?.toLowerCase()
      }))
      .filter(({ type }) => validTypes.includes(type));

    this.renderSuggestions(suggestions);
  },

  renderSuggestions: function (suggestions) {
    const ul = this.elements.suggestionsUl;
    ul.innerHTML = '';
    this.elements.header.style.display = 'none';
    this.elements.emptyMessage.style.display = 'none';

    const titleByType = { city: 'Cidades', beach: 'Praias', airport: 'Aeroportos' };
    const pathByType = { city: 'cidade', beach: 'litoral', airport: 'aeroporto' };
    const idKeyByType = { city: 'idcity', beach: 'idbeach', airport: 'idairport' };
    const keyByType = { city: 'city', beach: 'beach', airport: 'airport' };

    let globalIndex = 1;

    suggestions.forEach(({ places, type }) => {
      if (!places.length) return;

      const title = document.createElement('p');
      title.textContent = titleByType[type];
      ul.appendChild(title);

      places.forEach(place => {
        const name = place[keyByType[type]];
        const uf = place.uf === 'ND' && place.ac ? place.ac : place.uf;
        const label = `${name} - ${uf}`;
        const slug = slugify(String(name)).replaceAll("-", "").toLowerCase();
        const href = `/previsao-do-tempo/${pathByType[type]}/${place[idKeyByType[type]]}/${slug}-${uf.toLowerCase()}`;

        const li = document.createElement('li');
        li.className = 'autocomplete-item';

        const paddedIndex = String(globalIndex).padStart(2, '0');
        const aId = `Menu_MainNav_Item_NavLink-${paddedIndex}`;

        li.innerHTML = `
        <div class="autocomplete-content">
          <div>
            <a href="${href}" id="${aId}" data-id="${aId}">
              <span>${label}</span>
            </a>
          </div>
        </div>
      `;

        ul.appendChild(li);
        globalIndex++;
      });
    });
  },

  setupMyLocationButton: function () {
    if (!this.elements.myLocationButton) return;

    this.elements.myLocationButton.addEventListener('click', async () => {
      const button = this.elements.myLocationButton;
      const span = button.querySelector('span');
      const originalText = span ? span.textContent : '';
      if (span) span.textContent = 'Buscando...';
      button.disabled = true;

      const eventData = {
        event: 'click_button',
        id: 'Menu_MainNav_Button_UseLocation',
      };
      pushDatalayer(eventData);

      try {
        const location = await geolocation.userGeolocation(true);

        if (!location || !location.idcity || !location.city || !location.uf) {
          throw new Error('Dados de localização indisponíveis.');
        }

        const slug = slugify(String(location.city)).replaceAll("-", "").toLowerCase();
        const href = `/previsao-do-tempo/cidade/${location.idcity}/${slug}-${String(location.uf).toLowerCase()}`;

        window.location.href = href;
      } catch (error) {
        console.error('Erro ao processar localização na sidebar:', error);
        if (span) span.textContent = 'Erro ao buscar';
        setTimeout(() => {
          if (span) span.textContent = originalText;
          button.disabled = false;
        }, 3000);
      }
    });
  },

  renderSearchHistory: function () {
    this.elements.suggestionsUl.innerHTML = '';
    this.elements.header.style.display = 'flex';
    const history = [];
    if (history.length === 0) {
      this.elements.emptyMessage.style.display = 'block';
    }
  },

  debounce: function (fn, delay) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), delay);
    };
  }
};

function pushDatalayer(data) {
  window.dataLayer = window.dataLayer || []

  window.dataLayer.push(
    data)
}

function createAvatarInitial(name) {
  const initial = name.charAt(0).toUpperCase();
  const avatarDiv = document.createElement('div');
  avatarDiv.className = 'sidebar-user-avatar-initial';
  avatarDiv.textContent = initial;

  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const color = `hsl(${hash % 360}, 70%, 50%)`;
  avatarDiv.style.backgroundColor = color;

  return avatarDiv;
}

sidebar.init();

export default sidebar;
